//Componente importado de material ui
import { makeStyles } from '@material-ui/core/styles';
//Estilo genérico importado
import { estilosTextosPrincipales, colores } from '../../../AppStyle';
import { createMuiTheme } from '@material-ui/core';

export const customStyle = makeStyles({
    classGridPrincipal: {
        width: '75%',
        marginRight: '2.5%'
    },
    classGridPrincipalResponsive: {
        marginRight: '2.5%'
    },
    classTituloPrincipal: {
        fontWeight: 'bold',
        fontSize: '26px',
        fontStyle: 'normal',
        lineHeight: '32px',
        marginBottom: '2%',
    },
    classTituloSecundario: {
        fontWeight: 'bold',
        fontSize: '20px',
        fontStyle: 'normal',
        lineHeight: '32px',
        marginBottom: '2%',
        marginTop: '2%',
        borderBottom: `1px solid ${colores.escalaGrises.cien}`
    },
    classTituloTerciario: {
        fontWeight: 'bold',
        fontSize: '18px',
        fontStyle: 'normal',
        lineHeight: '32px',
        marginBottom: '2%',
        marginTop: '2%',
    },
    classParrafo: {
        marginBottom: '1%',
        fontWeight: '100',
    },
    classLista:{
        fontWeight: 'bold',
    },
    classOl:{
        marginLeft: '5%',
    },
    classUl:{
        marginBottom: '2%',
        marginLeft: '5%',
    },
    classGirdContainer: {
        display: 'inline-flex',
        margin: '2% 5%'
    },
    classGirdContainerResponsive: {
        margin: '2% 5%'
    },
    classGridIndice: {
        right: '0',
        height: '300px',
        width: '25%',
    },
    classGridIndiceResponsive: {
        marginBottom: '10%',
    },
    classGridRectangulo: {
        border: `1px solid ${colores.escalaGrises.cien}`,
        marginTop: '10%',
    },
    iconoAyuda:{
        color: colores.principales.principal,
    },
    classSubGridRectangulo: {
        display: 'inline-flex',
        padding: '12px',
    },
    classpRectangulo: {
        marginLeft: '20px',
    },
    classSubGridRectangulo2:{
        display: 'flex',
    },
    classpRectangulo2: {
        margin: 'revert',
    },
    classOlIndice:{
        marginLeft: '8%',
    },
    classLiIndice:{
        marginBottom: '3%',
        cursor: 'pointer',
    },
    classTituloIndice: {
        fontWeight: 'bold',
        fontSize: '18px',
        fontStyle: 'normal',
        lineHeight: '32px',
        marginBottom: '2%',
        marginTop: '2%',
        borderBottom: `1px solid ${colores.escalaGrises.apoyo}`,
    },
});
export const overInputs = createMuiTheme({
    overrides: {
        MuiIconButton: {
            root: {
                pointerEvents: 'none',
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.0)',
                },
            },
        }
    }
});